var React = require('react');

function SuccessIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.37.473L1.187 2.654.098 1.562l.409-.409.68.682L2.96.063z","fill":"#c6c6c6"}));
}

SuccessIcon.defaultProps = {"viewBox":"0 0 3.44 2.728","height":"10.312","width":"13"};

module.exports = SuccessIcon;

SuccessIcon.default = SuccessIcon;
